import React, { useEffect, useRef } from "react";
import styled from "styled-components";

interface ModalOverlayProps {
  width: string;
}

const ModalOverlay = styled.div<ModalOverlayProps>`
  position: absolute;
  top: 100%;
  left: 0;
  width: ${({ width }) => width};
  display: flex;
  justify-content: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

const Option = styled.div`
  padding: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  color: hsl(0, 0%, 36%);

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.blue400};
    color: white;
  }
`;

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  options: { value: string; label: string }[];
  onSelect: (value: string) => void;
  width: string;
}

const CustomModal: React.FC<CustomModalProps> = ({ isOpen, onClose, options, onSelect, width }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <ModalOverlay width={width}>
      <ModalContent ref={modalRef} onClick={(e) => e.stopPropagation()}>
        {options.map((option) => (
          <Option
            key={option.value}
            onClick={() => {
              onSelect(option.value);
              onClose();
            }}
          >
            {option.label}
          </Option>
        ))}
      </ModalContent>
    </ModalOverlay>
  );
};

export default CustomModal;
